<template>
    <div class="container-table2" style="max-width: 100% !important;">
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th v-for="column in columns" :key="column">{{ column }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in rows" :key="index" v-if="rows.length > 0">
                        <td v-for="column in columns" :key="column + index">
                            <a v-if="links && links[column]" :href="links[column](row[column])" class="link-table" target="_blank">{{ row[column] }}</a>
                            <template v-else>
                                
                                <span v-if="column === 'Status da venda'" :class="getBadge(row[column])">{{ getStatusText(row[column]) }}</span>
                                <span v-else-if="column === 'Status da assinatura'" :class="getBadge(row[column])">{{ getStatusText(row[column]) }}</span>
                                <span v-else-if="column === 'Telefone do cliente'">{{ formatPhoneNumber(row[column]) }}</span>
                                <span v-else>{{ row[column] }}</span>
                            </template>
                        </td>
                    </tr>
                    <tr style="border-width: 0;" v-if="!rows || rows.length == 0">
                        <td :colspan="columns.length" class="no-data">Não existem dados disponíveis.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "TableReportRefund",
    props: ["filter", "columns", "rows", "links"],
    data() {
        return {
            status: '',
            pagination: {
                totalPages: 1,
                currentPage: 1,
                perPage: 10,
            },
        }
    },
    methods: {
        formatPhoneNumber(phone) {
            if (!phone) return '';
            
            // Mantém o +55 original do telefone, sem modificá-lo
            if (phone.startsWith('+55')) {
                // Formata mantendo o código do país original
                return phone.replace(/(\+55)(\d{2})(\d{5})(\d{4})/, '$1 ($2) $3-$4');
            } else {
                return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
            }
        },
        getStatusText(status) {
            if (!status) return '';
            
            switch(status) {
                case 'processing': 
                    return this.$t('seller.contracts.text_2472');
                case 'authorized':
                    return this.$t('seller.contracts.text_2473');
                case 'paid':
                    return this.$t('seller.contracts.text_2473');
                case 'canceled':
                    return this.$t('seller.contracts.text_2458');
                case 'ended':
                    return this.$t('seller.contracts.text_2459');
                case 'refunded':
                    return this.$t('seller.contracts.text_2475');
                case 'waiting_payment':
                    return this.$t('seller.contracts.text_2476');
                case 'pending_payment':
                    return this.$t('seller.contracts.text_2474');
                case 'refund_pending':
                case 'pending_refund':
                    return this.$t('seller.contracts.text_2477');
                case 'refused':
                    return this.$t('seller.reports.text_2604');
                case 'chargedback':
                    return this.$t('seller.contracts.text_2475');
                case 'delayed':
                    return this.$t('seller.contracts.text_2456');
                case 'trialing':
                    return this.$t('seller.contracts.text_2481');
                case 'unpaid':
                    return this.$t('seller.contracts.text_2482');
            }
        },
        getBadge(status) {
            if (!status || status === '-') return '';
            
            const statusMap = {
                'processing': 'badge badge-processing',
                'authorized': 'badge badge-paid',
                'paid': 'badge badge-paid',
                'canceled': 'badge badge-canceled',
                'ended': 'badge badge-ended',
                'refunded': 'badge badge-refunded',
                'waiting_payment': 'badge badge-waiting_payment',
                'pending_payment': 'badge badge-pending_payment',
                'refund_pending': 'badge badge-refund_pending',
                'pending_refund': 'badge badge-pending_refund',
                'refused': 'badge badge-refused',
                'chargedback': 'badge badge-chargedback',
                'delayed': 'badge badge-delayed',
                'trialing': 'badge badge-trialing',
                'unpaid': 'badge badge-unpaid',
            };
            
            return statusMap[status.toLowerCase()] || '';
        }
    }
};
</script>

<style scoped>
    .no-data {
        color: #4B5563;
        text-align: center;  
        padding: 44px 0px 44px 0px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .container-table2 {
        width: 100%;
        max-width: 1700px;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
    }
    .table-responsive {
        width: 100%;
        overflow-x: auto;
    }
    .link-table {
        color: var(--Default-primary-800, #0854C5);

        /* text-sm/leading-5/font-medium */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }
    table {
        width: 100%;
        border-collapse: collapse;
    }
    th {
        background-color: #F3F4F6;
        color: #475467;
        font-size: 13px;
        line-height: 18px;
        font-family: Inter;
        font-weight: 500;
        text-align: left;
        white-space: normal;
    }
    th, td {
        padding: 8px 8px;
        border: none;
    }
    td {
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    tr:not(:last-child) {
        border-bottom: 1px solid #EAECF0;
    }

    

    /* Badge */
    .badge {
        height: 25px;
        border-radius: 16px;
        padding: 8px 12px 8px 12px;
    }

    .badge-paid {
        background: #D1FAE5;
        color: #065F46
    }

    .badge-processing {
        background: #D6F0FF;
        color: #0854C5;
    }

    .badge-authorized {
        background: #D6F0FF;
        color: #0854C5;
    }

    .badge-refused {
        background: #FEE2E2;
        color: #92400E;
    }

    .badge-unpaid {
        background: #FEF3C7;
        color: #92400E;
    }

    .badge-refunded {
        background: #F3F4F6;
        color: #1F2937;
    }

    .badge-chargedback {
        background: #D1FAE5;
        color: #000000
    }

    .badge-canceled {
        background: #D1FAE5;
        color: #000000
    }

    .badge-ended {
        background: #F2F4F7;
        color: #344054;
    }

    .badge-trialing {
        background: #FEF3C7;
        color: #92400E;
    }

    .badge-waiting_payment {
        background: #FEF3C7;
        color: #92400E;
    }

    .badge-pending_payment {
        background: #fef2f2;
        color: #dc2626;
    }

    .badge-refund_pending {
        background: #FEF3C7;
        color: #92400E;
    }

    .badge-canceled {
        background: #FEE4E2;
        color: #B42318;
    }

    .badge-ended {
        background: #F2F4F7;
        color: #344054;
    }

    .badge-unpaid {
        background: #FEF3C7;
        color: #92400E;
    }

    .badge-delayed {
        background: #FEF3C7;
        color: #92400E;
    }

    .badge-created {
        background: #D6F0FF;
        color: #0854C5;
    }

</style>
